module.exports = __webpack_public_path__ + "static/img/lgonn.38cce68.png";


//////////////////
// WEBPACK FOOTER
// ./static/img2/lgonn.png
// module id = SOCH
// module chunks = 3